// Normaliza el nombre de un barrio guardado en jsonb.
// Soporta strings planos, objetos nuevos {nombre_barrio} y viejos {value, label} del react-select.
export const nombreBarrioJson = (b) => {
  if (b == null) return '';
  const raw = typeof b === 'string' ? b : (b?.nombre_barrio || b?.nombre_del_barrio || b?.label || '');
  return String(raw)
    .replace(/^\d+\s*-\s*/, '') // prefijo "1234567 - Nombre" (opciones RPPVAP)
    .replace(/\s*\(\d+\)\s*$/, '') // sufijo "(id)" (opciones RENABAP)
    .trim();
};

// Convierte un array jsonb de barrios en texto con separador (default " - ")
export const barriosJsonATexto = (arr, separador = ' - ') =>
  Array.isArray(arr) ? arr.map(nombreBarrioJson).filter(Boolean).join(separador) : '';
